import { clsx } from "clsx";
import { motion } from "framer-motion";
import type { ReactNode } from "react";

type CardVariant = "default" | "success" | "warning" | "info" | "error";

type CardProps = {
  variant?: CardVariant;
  animate?: boolean;
  children: ReactNode;
  className?: string;
};

const variantStyles: Record<CardVariant, string> = {
  default: "glass-card-solid",
  success: "glass-card-solid border-l-4 border-l-success-border bg-success-bg/80",
  warning: "glass-card-solid border-l-4 border-l-warning-border bg-warning-bg/80",
  info: "glass-card-solid border-l-4 border-l-info-border bg-info-bg/80",
  error: "glass-card-solid border-l-4 border-l-error-border bg-error-bg/80",
};

export const Card = ({ variant = "default", animate = true, children, className }: CardProps) => {
  const baseClassName = clsx(
    "rounded-2xl p-5 shadow-card transition-shadow duration-200",
    variantStyles[variant],
    className,
  );

  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className={baseClassName}
      >
        {children}
      </motion.div>
    );
  }

  return <div className={baseClassName}>{children}</div>;
};
